import * as t from 'ts-schema';
const HubSpotWindowSchema = t.object({
  sessionId: t.string,
  bender: t.object({
    currentProject: t.string
  })
});
export const getHubSpotWindowInfo = win => {
  if (t.validate(HubSpotWindowSchema, win.hubspot)) {
    return {
      sessionId: win.hubspot.sessionId,
      benderProject: win.hubspot.bender.currentProject
    };
  }
  return undefined;
};